/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
import { Dispatch } from 'redux';
import { IPersonalInformation } from 'src/interfaces/personal-info';
import personalInfoService from 'src/services/personal-info.service';

import { PersonalInfoActionType } from '../action-types';
import { PersonalInfoAction } from '../actions';

export const getPersonalInfo = () => async (dispatch: Dispatch<PersonalInfoAction>) => {
  dispatch({
    type: PersonalInfoActionType.GET_PERSONAL_INFO,
  });

  try {
    const { data }: { data: IPersonalInformation } = await personalInfoService.getPersonalInformation();

    dispatch({
      type: PersonalInfoActionType.GET_PERSONAL_INFO_SUCCESS,
      payload: { personalInfo: data },
    });
  } catch (err: any) {
    dispatch({
      type: PersonalInfoActionType.GET_PERSONAL_INFO_FAILURE,
      payload: err.message,
    });
  }
};
